﻿import { Component, HostBinding, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';

import {  ViewCell } from 'ng2-smart-table';
import { DecimalPipe } from '@angular/common';
import { Pipe } from '@angular/core';

@Component({
    template: '<div style="text-align:right;">{{renderValue}}</div>',
})

@Pipe({name: 'numberview'})
export class NumberViewComponent extends DecimalPipe implements ViewCell, OnInit {

    renderValue: string;

    @Input() value: string | number;
    @Input() rowData: any; 

    ngOnInit() {
        this.renderValue = super.transform(this.value,"0.0","vi");
    }

}